// extracted by mini-css-extract-plugin
module.exports = {"Icon__clickable":"Icon_Icon__clickable__2w_N_","fadein":"Icon_fadein__3dhz-"};